import { FC, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Setting } from '../../types/constant/PagesPropsType';
import cancelPauseLinkClass from '../../assets/scss/SubscriptionDetail/CancelPauseLink.module.scss';
import { PauseConfirmModal } from '../PauseConfirmModal/PauseConfirmModal';
import { useUpdateSubscriptionStatus } from '../../hooks/use-update-subscription-status';
import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';
import { PauseConfirmModalViewType } from '../../types/view/PauseConfirmModalViewType';
import { postMessageGtag } from '../../utils/trackClick';
import { SkipModalViewType } from '../../types/view/SkipModalViewType';

export const CancelPauseLink: FC<{
  cancelPauseInfo: {};
  id: string;
  setting: Setting;
  subscription: SubscriptionApiType;
  loading: boolean;
  toggleLoading: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSkipModal: React.Dispatch<React.SetStateAction<SkipModalViewType | null>>;
  onSwitchToRecommended: () => void;
  returnToPauseModal: boolean;
  setReturnToPauseModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  cancelPauseInfo,
  id,
  setting,
  subscription,
  loading,
  toggleLoading,
  toggleSkipModal,
  onSwitchToRecommended,
  returnToPauseModal,
  setReturnToPauseModal,
}) => {
  const history = useHistory();
  const { pauseSubscription } = useUpdateSubscriptionStatus();

  // 停止確認モーダルのデータ
  const [pauseConfirmModal, setPauseConfirmModal] = useState<PauseConfirmModalViewType | null>(
    null
  );

  const clickPauseLinkHandler = () => {
    setPauseConfirmModal({
      clickSkipLinkFunc: () => {
        setPauseConfirmModal(null);
        toggleSkipModal({ isOpen: true });
      },
      thanksmilePoints,
      route: 'old',
    });
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleClass = () => {
    if (!isOpen) {
      // アコーディオンが開く分の高さ調整
      const height = document.querySelector('body')!.scrollHeight;
      setting.resize(height + 700);
    }
    setIsOpen(!isOpen);
  };

  // サンクスマイル
  const [thanksmilePoints, setThanksmilePoints] = useState('');
  useEffect(() => {
    if (!isOpen) return;

    window.parent.postMessage({ action: 'thanksmile' }, '*');

    const fetchThanksmile = (event: MessageEvent<any>) => {
      if (event.data.action && event.data.action === 'thanksmile') {
        setThanksmilePoints(event.data.points);
      }
    };

    window.addEventListener('message', fetchThanksmile);

    return () => window.removeEventListener('message', fetchThanksmile);
  }, [isOpen]);

  // returnToPauseModalが変更されたとき
  useEffect(() => {
    if (returnToPauseModal) {
      console.log('returnToPauseModal');
      // 停止モーダルを再表示
      setPauseConfirmModal({
        clickSkipLinkFunc: () => {
          setPauseConfirmModal(null);
          toggleSkipModal({ isOpen: true });
        },
        thanksmilePoints,
        route: 'old',
      });
      // フラグをリセット
      setReturnToPauseModal(false);
    }
  }, [returnToPauseModal]);

  let pauseModalLink = <></>;
  let cancelPageLink = <></>;
  // 最低購入回数を満たしている場合のみリンクが有効になる
  if (cancelPauseInfo['canCancelPause']) {
    pauseModalLink = (
      <button
        className={cancelPauseLinkClass.cancelPauseLinkOldSubsc}
        onClick={() => {
          clickPauseLinkHandler();
          postMessageGtag('click_open_PausePage_oldSubsc', 'detailSettings');
        }}
      >
        定期オトク便を停止する
      </button>
    );

    cancelPageLink = (
      <Link
        className={`${cancelPauseLinkClass.cancelPauseLinkOldSubsc} ${cancelPauseLinkClass.padding}`}
        onClick={() => {
          postMessageGtag('click_open_CancelPage', 'detailSettings');
        }}
        to={`/cancel/${encodeURIComponent(id)}`}
      >
        定期オトク便を解約する
      </Link>
    );
  } else {
    pauseModalLink = (
      <p className={cancelPauseLinkClass.cancelPauseGuidanceOldSubsc}>
        ご案内：{cancelPauseInfo['minCycle'] + 1}回目のお届けから停止可能
      </p>
    );

    cancelPageLink = (
      <p
        className={`${cancelPauseLinkClass.cancelPauseGuidanceOldSubsc} ${cancelPauseLinkClass.padding}`}
      >
        ご案内：{cancelPauseInfo['minCycle'] + 1}回目のお届けから解約可能
      </p>
    );
  }

  return (
    <>
      <div
        className={`${cancelPauseLinkClass.changeContractStatus} ${
          isOpen ? cancelPauseLinkClass.changeContractStatusOpen : ''
        }`}
      >
        <button
          className={cancelPauseLinkClass.title}
          onClick={() => {
            toggleClass();
            postMessageGtag('click_open_SettingCancel', 'detailSettings');
          }}
        >
          お届けを止める
          <span
            className={`${isOpen ? cancelPauseLinkClass.angleUp : cancelPauseLinkClass.angleDown}`}
          ></span>
        </button>
        <div className={`${isOpen ? cancelPauseLinkClass.open : cancelPauseLinkClass.closed}`}>
          <p className={cancelPauseLinkClass.overview}>
            定期オトク便のお届けを停止します。
            <br />
            「停止」または「解約」のいずれかを選択ください。どちらを選択してもご請求も、商品のお届けも一切発生しません。
          </p>
          <div className={cancelPauseLinkClass.typeBlock}>
            <div className={cancelPauseLinkClass.typeTitleBlock}>
              <span className={cancelPauseLinkClass.typeTitle}>停止</span>
              <span className={cancelPauseLinkClass.recommendation}>おすすめ</span>
            </div>
            <p className={cancelPauseLinkClass.explanation}>
              「食べきれない」「少し余った」場合は停止がおすすめです。
              <br />
              住所登録等、一からの登録が不要で、マイアカウントから簡単に再開が可能です。
            </p>
            {pauseModalLink}
          </div>
          <div className={cancelPauseLinkClass.typeBlock}>
            <span className={cancelPauseLinkClass.typeTitle}>解約</span>
            <p className={cancelPauseLinkClass.explanation}>
              定期契約を解約します。
              <br />
              残念ながらいずれの定期商品にも再度申し込むことができません。
              <br />
              初回限定の特別価格でお届けするため、ZENBの定期オトク便は、一世帯様一回限り（いずれか1セット）の特典としてます。
            </p>
            {cancelPageLink}
          </div>
        </div>
      </div>

      {/* 停止モーダル */}
      <PauseConfirmModal
        active={pauseConfirmModal !== null}
        closeFunc={() => setPauseConfirmModal(null)}
        pauseConfirmModal={pauseConfirmModal}
        clickSubmitFunc={() => {
          toggleLoading(true);
          pauseSubscription(
            setting,
            subscription!,
            () => {
              setPauseConfirmModal(null);
              window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
              history.push('/');
            },
            () => {},
            () => {
              toggleLoading(false);
            }
          );
        }}
        onSwitchToRecommended={onSwitchToRecommended}
        loading={loading}
        setting={setting}
        subscription={subscription}
      />
    </>
  );
};
